import React from 'react';
import { useTheme } from 'ThemeContext';

import { Item, ItemExternal, Icon, Text } from './WidgetIcon.style';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function WidgetIcon({ data = {}, theme_id }) {
  const theme = useTheme();
  const renderItemInner = data => {
    return (
      <>
        {data.icon ? (
          <Icon
            size={data.size}
            theme={theme.widgetIcon.icon}
            style={{
              backgroundColor:
                data.color && theme_id === 6 ? data.color : undefined
            }}
          >
            <FontAwesomeIcon icon={data.icon.split(',')} />
          </Icon>
        ) : (
          ''
        )}
        {data.text ? (
          <Text theme={theme.widgetIcon.text}>{data.text}</Text>
        ) : (
          ''
        )}
      </>
    );
  };

  return (
    <>
      {(data.slug && /(http(s?)):\/\//gi.test(data.slug)) ||
      (data.link && /(http(s?)):\/\//gi.test(data.link)) ||
      (data.url && /(http(s?)):\/\//gi.test(data.url)) ||
      data.url_outside ? (
        <ItemExternal
          aria-label={
            'link' + data.slug || data.link || data.url || data.url_outside
          }
          theme={theme.widgetIcon.item}
          title={data.text}
          href={data.slug || data.link || data.url || data.url_outside}
          target={
            data._blank ||
            data.link_blank ||
            data.url_blank ||
            data.url_outside_blank
              ? '_blank'
              : '' || data.target || ''
          }
          rel={
            data.nofollow ||
            data.link_nofollow ||
            data.url_nofollow ||
            data.url_outside_nofollow
              ? 'nofollow'
              : '' || data.rel || ''
          }
          color={theme_id !== 6 && data.color}
        >
          {renderItemInner(data)}
        </ItemExternal>
      ) : data.slug || data.link ? (
        <Item
          aria-label={(() => {
            let slug;
            if (data.slug)
              slug = data.slug[0] === '/' ? data.slug : `/${data.slug}`;
            else if (data.link)
              slug = data.link[0] === '/' ? data.link : `/${data.link}`;
            else slug = '';

            return 'link' + slug;
          })()}
          theme={theme.widgetIcon.item}
          title={data.text}
          smooth
          to={(() => {
            let slug;
            if (data.slug)
              slug = data.slug[0] === '/' ? data.slug : `/${data.slug}`;
            else if (data.link)
              slug = data.link[0] === '/' ? data.link : `/${data.link}`;
            else slug = '';

            return slug;
          })()}
          color={theme_id !== 6 && data.color}
        >
          {renderItemInner(data)}
        </Item>
      ) : (
        ''
      )}
    </>
  );
}

export default WidgetIcon;
